const updateRoute = (state, action) => {
  if(state===undefined || action?.type==='RESET'){
    return {
      routeArr: undefined,
      routeSettingsArr: undefined,
      paletteStatus: undefined,
    }
  }
  const { route:data } = state;

  switch(action.type){
    case 'SET_ROUTE_ROUTE_ARR':
      return {...data, routeArr: action.payload};
    case 'SET_ROUTE_ROUTE_SETTINGS_ARR':
      return {...data, routeSettingsArr: action.payload};
    case 'SET_ROUTE_PALETTE_STATUS':
      return {...data, paletteStatus: action.payload};

    default:
      return data;
  }
}

export default updateRoute;
